export const TEST_ID = 'chemicalDetailCropRates';
